import { useSearchParams } from "react-router-dom"

export const getQueryParameter = (queryParamName: string) => {
    if (queryParamName !== '' && queryParamName != undefined) {
        const [searchParams] = useSearchParams()
        return searchParams.get(queryParamName)
    }
}